<template>
    <div class="blog-content">
        <time
            :datetime="publishedAt"
            class="date"
            v-test:publishedAt
        >
            {{ formattedDate }}
        </time>

        <markdown-content
            :content="content"
        />
    </div>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import dayjs from 'dayjs';

    export default {
        name: 'blog-content',

        components: { MarkdownContent },

        props: {
            publishedAt: {
                type: String,
                default: '',
            },

            content: {
                type: String,
                required: true,
            },
        },

        computed: {
            /**
             * Formatted date.
             *
             * @returns {string}
             */
            formattedDate() {
                return dayjs(this.publishedAt)
                    .format('DD/MM/YY');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .date {
        font-size: rem(20px);
        line-height: rem(24px);
        font-weight: 700;
        margin-bottom: 13px;
        display: block;
    }

    .markdown-content ::v-deep {
        @include media-breakpoint-up(lg) {
            font-size: rem(20px);
            line-height: rem(32px);
        }

        // Get some consistent heading sizes going, using the h5 sizes as the base calculation
        @for $i from 2 through 6 {
            h#{ $i } {
                font-size: map-get($heading-font-sizes-mobile, h5) * (1 - (0.075 * ($i - 2)));
                font-weight: bold;

                @include media-breakpoint-up(lg) {
                    font-size: map-get($heading-font-sizes-desktop, h5) * (1 - (0.075 * ($i - 2)));
                }
            }
        }
    }
</style>
